import { CookiesSettingsRaw } from "./useCookiesSettings.types";

export const transformCookiesSettingsResponse = (
  responseData: CookiesSettingsRaw
): boolean => responseData?.cookie_enabled === false;
